import axios from './Instance/axiosInstance';

export interface Currency {
    id?: string;
    code: string;
    rateToIQD: number;
    symbol: string;
    isDefault: boolean;
}

export const getCurrencies = () => axios.get<Currency[]>('/currencies');
export const getCurrency = (id: string) => axios.get<Currency>(`/currencies/${id}`);
export const createCurrency = (data: Currency) => axios.post<Currency>('/currencies', data);
export const updateCurrency = (id: string, data: Currency) => axios.put<Currency>(`/currencies/${id}`, data);
export const deleteCurrency = (id: string) => axios.delete(`/currencies/${id}`);
